export const benefit = {
  'And a good friendship is where is get double the discount! Your friends <1>also have a discount of {{discount}}</1> to get their hair removal up to date!':
    '¡Y la amistad realmente buena es cuando hay un descuento doble! ¡Tus amigas <1>también obtienen un descuento de {{discount}}</1> para garantizar su depilación a tiempo!',
  'Could not recommend the following people {{customers}}':
    'No fue posible indicar a las siguientes personas: {{customers}}',
  'Loading data': 'Cargando datos...',
  Name: 'Nombre',
  'Name of the recommended person': 'Nombre de persona indicada',
  'Please, inform a fullname': 'Por favor, informe el nombre completo',
  'Please, inform a valid number': 'Por favor, libere un numero válido',
  PHONE_PLACEHOLDER: '0000-00000',
  Recommend: 'Indicar',
  Recommendation: 'Indicación',
  'Recommendations successfully made!': '¡Indicaciones hechas con éxito!',
  'The discount is valid only on purchases of packages worth more than <1>{{value}}</1>':
    'Descuento válido para compras de paquetes con valores superiores a <1>{{value}}</1>',
};
